import ooredoo10 from "../../../assests/images/bundles/ooredoo/ooredoo-10.png";
import ooredoo15 from "../../../assests/images/bundles/ooredoo/ooredoo-15.png";
import ooredoo20 from "../../../assests/images/bundles/ooredoo/ooredoo-20.png";
import ooredoo25 from "../../../assests/images/bundles/ooredoo/ooredoo-25.png";
import ooredoo30 from "../../../assests/images/bundles/ooredoo/ooredoo-30.png";
import ooredoo35 from "../../../assests/images/bundles/ooredoo/ooredoo-35.png";
import ooredoo40 from "../../../assests/images/bundles/ooredoo/ooredoo-40.png";
import ooredoo45 from "../../../assests/images/bundles/ooredoo/ooredoo-45.png";
import ooredoo50 from "../../../assests/images/bundles/ooredoo/ooredoo-50.png";
import ooredoo60 from "../../../assests/images/bundles/ooredoo/ooredoo-60.png";
import ooredoo70 from "../../../assests/images/bundles/ooredoo/ooredoo-70.png";
import ooredoo80 from "../../../assests/images/bundles/ooredoo/ooredoo-80.png";
import ooredoo90 from "../../../assests/images/bundles/ooredoo/ooredoo-90.png";
import ooredoo100 from "../../../assests/images/bundles/ooredoo/ooredoo-100.png";
import ooredoo200 from "../../../assests/images/bundles/ooredoo/ooredoo-200.png";
import OoredooEmpty from "../../../assests/images/bundles/ooredoo/ooredoo_empty.png";

export const EMPTY_OOREDOO_CREDIT = {
  dis: "",
  price: "1000",
  url: OoredooEmpty,
  id: "1000",
  flexiblePrice: true,
  type: "creditEmpty",
};

const OOREDOO_CREDITS = [
  {
    dis: "",
    price: "10",
    url: ooredoo10,
    id: "1010",
    type: "credit",
  },
  {
    dis: "",
    price: "15",
    url: ooredoo15,
    id: "1015",
    type: "credit",
  },
  {
    dis: "",
    price: "20",
    url: ooredoo20,
    id: "1020",
    type: "credit",
  },
  {
    dis: "",
    price: "25",
    url: ooredoo25,
    id: "1025",
    type: "credit",
  },
  {
    dis: "",
    price: "30",
    url: ooredoo30,
    id: "1030",
    type: "credit",
  },
  {
    dis: "",
    price: "35",
    url: ooredoo35,
    id: "1035",
    type: "credit",
  },
  {
    dis: "",
    price: "40",
    url: ooredoo40,
    id: "1040",
    type: "credit",
  },
  {
    dis: "",
    price: "45",
    url: ooredoo45,
    id: "1045",
    type: "credit",
  },
  {
    dis: "",
    price: "50",
    url: ooredoo50,
    id: "1050",
    type: "credit",
  },
  {
    dis: "",
    price: "60",
    url: ooredoo60,
    id: "1060",
    type: "credit",
  },
  {
    dis: "",
    price: "70",
    url: ooredoo70,
    id: "1070",
    type: "credit",
  },
  {
    dis: "",
    price: "80",
    url: ooredoo80,
    id: "1080",
    type: "credit",
  },
  {
    dis: "",
    price: "90",
    url: ooredoo90,
    id: "1090",
    type: "credit",
  },
  {
    dis: "",
    price: "100",
    url: ooredoo100,
    id: "10100",
    type: "credit",
  },
  {
    dis: "",
    price: "200",
    url: ooredoo200,
    id: "10200",
    type: "credit",
  },
];

export default OOREDOO_CREDITS;
export { EMPTY_OOREDOO_CREDIT as EMPTY_CREDIT };
